import React from "react";
import { connect } from "react-redux";
import ListItem from "components/ListItem/ListItem";
import { getNextWeek } from "utils/test";
import { reqNoticeList } from "store/Notice/Notice.store";

type Props = {
  list: any;
  setLoading: (bool: boolean) => any;
  reqNoticeList: any;
  device: any;
};

const NoticeList: React.FC<Props> = ({ list, setLoading }) => {
  const [isView, setView] = React.useState(true);
  // const [now2, setNow] = React.useState("");

  React.useEffect(() => {}, []);
  React.useEffect(() => {
    setLoading(false);
  }, [list, setLoading]);

  React.useEffect(() => {
    if (list.length === 0) setView(false);
    else setView(true);
  }, [list]);

  return (
    <ul className="NoticeList">
      {list.map((listItem: any, index: number) => (
        <ListItem
          type={listItem.type}
          title={listItem.title}
          key={`${listItem.n_seq}_${index}`}
          id={listItem.n_seq}
          date={listItem.view_start_date}
          isTop={listItem.top_yn === "Y"}
          poc={listItem.poc}
          criteria={getNextWeek(-7)}
        />
      ))}
      {!isView && (
        <p style={{ textAlign: "center", marginTop: "15px" }}>
          등록된 공지사항이 없습니다.
        </p>
      )}
    </ul>
  );
};

export default connect(
  ({ Notice, Layout }: { Notice: any; Layout: any }) => ({
    noticeList: Notice.noticeList,
    checkList: Notice.checkList,
    device: Layout.device,
  }),
  {
    reqNoticeList,
  }
)(NoticeList);
